import { render } from "./whiteCard.vue?vue&type=template&id=4293a6a0&scoped=true"
import script from "./whiteCard.vue?vue&type=script&lang=js"
export * from "./whiteCard.vue?vue&type=script&lang=js"

import "./whiteCard.vue?vue&type=style&index=0&id=4293a6a0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4293a6a0"

export default script